<script lang="ts">
import { defineComponent } from 'vue';
import { DomainConfig } from '@/util/env';
import SearchMenuDropDownItem from '@/components/layout/menu/search-menu-dropdown.vue';
import { Constants } from '@fibl/oxs-common';
import antragsstellungSvg from '@/assets/svg/Antragsstellung.svg';
import autstaticSvg from '@/assets/svg/AutStatics.svg';
import customclassificationSvg from '@/assets/svg/CustomClassification.svg';
import laenderauswahlSvg from '@/assets/svg/LinkOXS.svg';
import weiterleitungzurdbSvg from '@/assets/svg/Link4RDB.svg';
import loginSvg from '@/assets/svg/Login.svg';

export default defineComponent({
	name: 'ImportantOXSLinks',

	components: { SearchMenuDropDownItem},

	data: () => ({
		antragsstellungSvg,
		autstaticSvg,
		customclassificationSvg,
		laenderauswahlSvg,
		weiterleitungzurdbSvg,
		loginSvg,
	}),
	computed: {
		website() {
			return this.$globalStore.websiteStore.websiteCode;
		},

		isGuest() {
			return this.$globalStore.tokenStore.isGuest;
		},
		isSup() {
			return this.$globalStore.tokenStore.role === 'sup';
		},
		loggedIn() {
			return (
				this.$globalStore.tokenStore.ready && !!this.$globalStore.tokenStore.main.account
			);
		},
		rdbUrl() {
			const rdbRoute = Object.entries(DomainConfig).find(
				([_, code]) => code === Constants.WEB_RDB,
			);
			if (rdbRoute) {
				const l = document.location;
				let url = new URL(`${l.protocol}//${rdbRoute[0]}`);
				if (url.hostname === l.hostname) {
					url.port = l.port;
				}
				return url.href;
			}
			return null;
		},
		oxsUrl() {
			const oxsRoute = Object.entries(DomainConfig).find(([_, code]) => code === 'OXSSELECT');
			if (oxsRoute) {
				const l = document.location;
				let url = new URL(`${l.protocol}//${oxsRoute[0]}`);
				if (url.hostname === l.hostname) {
					url.port = l.port;
				}
				return url.href;
			}
			return null;
		},
		language() {
			return this.$globalStore.websiteStore.locale;
		}
	},

	methods: {
		routeToRDBwithLang(path?: string) {
			if(!this.rdbUrl) return;
			const url = new URL(path ? `${this.rdbUrl}${path}` : this.rdbUrl);
			url.searchParams.set('lang', this.language);
			window.location.href = url.toString();
		},
		routeToClassification() {
			this.routeToRDBwithLang('classification/list');
		},
		routeToRDB() {
			this.routeToRDBwithLang();
		},
		routeToLanguageSelect() {
			if (this.oxsUrl) window.location.href = this.oxsUrl;
		},
		ssoLogin() {
			this.$globalStore.tokenStore.authenticate();
		},
		openSelfRegisterAgr() {
			this.$router.push({ name: 'RegisterAgrWithUploadedAccount' });
		},
		routeToAutStatistics() {
			this.routeToRDBwithLang('cms/aut-statistics');
		},
	},
});
</script>

<template>
	<div class="rounded-md shadow-md overflow-hidden mb-4">
		<el-carousel
			height="500px"
			trigger="click"
		>
			<el-carousel-item>
				<img src="@/assets/images/oxs1.jpg" />
			</el-carousel-item>
			<el-carousel-item>
				<img src="@/assets/images/oxs2.jpg" />
			</el-carousel-item>
			<el-carousel-item>
				<img src="@/assets/images/oxs3.jpg" />
			</el-carousel-item>
		</el-carousel>
	</div>

	<div class="grid grid-flow-col auto-cols-fr gap-4 items-baseline">
		<el-link
			v-if="!loggedIn && !isGuest"
			@click="ssoLogin">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="loginSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.login.login') }}</span>
			</div>
		</el-link>
		<el-link
			v-if="isGuest && !loggedIn"
			@click="openSelfRegisterAgr">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="loginSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.login.selfAgr') }}</span>
			</div>
		</el-link>
		<el-dropdown v-else-if="!isGuest && loggedIn" class="justify-center !leading-[inherit]">
			<el-link>
				<div class="flex flex-col items-center p-3 mb-3">
					<div class="pictogram mb-2">
						<el-image :src="antragsstellungSvg" style="width: 100px; height: 100px;"/>
					</div>
					<span class="text-center">{{ $t('components.menu.requestCreate') }}</span>
				</div>
			</el-link>
			<template #dropdown>
				<el-dropdown-menu>
					<SearchMenuDropDownItem :route-to-request="true" />
				</el-dropdown-menu>
			</template>
		</el-dropdown>
		<el-link @click="routeToRDB">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="weiterleitungzurdbSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.toRDB') }}</span>
			</div>
		</el-link>
		<el-link @click="routeToLanguageSelect">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="laenderauswahlSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.languageSelect') }}</span>
			</div>
		</el-link>
		<el-link @click="routeToClassification">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="customclassificationSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.customClassification') }}</span>
			</div>
		</el-link>
		<el-link @click="routeToAutStatistics">
			<div class="flex flex-col items-center p-3 mb-3">
				<div class="pictogram mb-2">
					<el-image :src="autstaticSvg" style="width: 100px; height: 100px;"/>
				</div>
				<span class="text-center">{{ $t('components.menu.autStats') }}</span>
			</div>
		</el-link>
	</div>
	<el-divider />
</template>
